import { z } from 'zod';

export const zodBulkDeleteTaxCodesPayloadSchema = z.object({
  ids: z.array(z.uuid()).min(1).max(500),
});

export const zodBulkDeleteTaxCodesEndpointSchema = z.tuple([
  z.literal('tax_codes'),
  z.literal('bulk_delete'),
]);
